module.exports = __webpack_public_path__ + "img/2.9566a60f.png";